/**
 * First-login product tour, driven by the backend `tour_completed` flag.
 *
 * The login response carries `tour_completed`; it is persisted so the shell knows
 * whether to show the welcome tour. As soon as the user skips or starts the tour,
 * /users/set_tour_completed flips the flag in the backend so later logins skip it.
 * Replays from the account menu ("Take a product tour") don't touch the flag.
 */
import axiosInstance from '../api/axiosInstance';

const STORAGE_KEY = 'tour_completed';

/** Store the flag from the login response. A missing value clears it so no tour is forced. */
export const setTourCompleted = (tourCompleted) => {
  try {
    if (typeof tourCompleted === 'boolean') {
      localStorage.setItem(STORAGE_KEY, String(tourCompleted));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* ignore */
  }
};

/** True only when the backend said this user has not been through the tour yet. */
export const isTourPending = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'false';
  } catch {
    return false;
  }
};

/**
 * Record the user's skip / start choice. Flipped locally first so reloads and repeat
 * clicks don't re-trigger it; if the request fails the backend still says false and
 * the tour is offered again on the next login.
 */
export const markTourCompleted = () => {
  if (!isTourPending()) return;
  setTourCompleted(true);
  axiosInstance
    .post('/users/set_tour_completed', null, { skipGlobalLoader: true, skipGlobalToast: true })
    .catch((error) => {
      console.error('[ProductTour] Failed to save tour completion:', error);
    });
};
